<div class="container-fluid pt-4">
      <div>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="card flex-fill p-0" id="card-state">
              <div class="card-header bg-white border-bottom-0">
              </div>
              <div class="card-body p-3">
                <div class="row">
                  <!-- Gráfico principal - 8 columnas -->
                  <div class="col-xl-8 col-lg-12 col-md-12">
                    <div class="card h-100 shadow-sm">
                      <div class="card-header bg-white border-bottom-0">
                        <h5 class="card-title mb-0">{{ getChartTitle() }}</h5>
                      </div>
                      <div class="card-body p-3">
                        <div class="chart-controls d-flex gap-2 flex-wrap mb-3">
                          <div class="btn-group btn-group-sm" role="group" aria-label="Tipo de datos">
                            <button type="button"
                                    class="btn btn-outline-primary"
                                    [ngClass]="{'active': chartDataType === 'consumption'}"
                                    (click)="switchChartDataType('consumption')"
                                    title="Ver consumo en kWh">
                              <i class="fas fa-bolt"></i>
                              <span class="d-none d-md-inline ms-1">Consumo</span>
                            </button>
                            <button type="button"
                                    class="btn btn-outline-primary"
                                    [ngClass]="{'active': chartDataType === 'time'}"
                                    (click)="switchChartDataType('time')"
                                    title="Ver tiempo de uso">
                              <i class="fas fa-clock"></i>
                              <span class="d-none d-md-inline ms-1">Tiempo</span>
                            </button>
                          </div>
                          <div class="btn-group btn-group-sm" role="group" aria-label="Tipo de vista">
                            <button type="button"
                                    class="btn btn-outline-primary"
                                    [ngClass]="{'active': chartViewType === 'monthly'}"
                                    (click)="switchChartViewType('monthly')"
                                    title="Ver datos mensuales">
                              <i class="fas fa-calendar-alt"></i>
                              <span class="d-none d-md-inline ms-1">Mensual</span>
                            </button>
                            <button type="button"
                                    class="btn btn-outline-primary"
                                    [ngClass]="{'active': chartViewType === 'total'}"
                                    (click)="switchChartViewType('total')"
                                    title="Ver totales acumulados">
                              <i class="fas fa-chart-line"></i>
                              <span class="d-none d-md-inline ms-1">Anual</span>
                            </button>
                          </div>
                        </div>
                        <div class="chart-container-full mb-2">
                          <canvas id="unifiedChart" #unifiedChart></canvas>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Tarjetas de métricas - 4 columnas -->
                  <div class="col-xl-4 col-lg-12 col-md-12">
                    <div class="d-flex flex-column gap-2">
                      <div class="row g-2">
                        <div class="col-6">
                          <div class="card card-element h-100 d-flex flex-column justify-content-center align-items-center text-center">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Conexión</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid" [ngClass]="getCtmConnectionIcon()" [style.color]="getCtmConnectionColor()"></i>
                            </span>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card card-element h-100 d-flex flex-column justify-content-center align-items-center text-center">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Estado actual</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid" [ngClass]="getCtmStatusIcon()" [style.color]="getCtmStatusColor()"></i>
                              {{ getCtmStatus() }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="row g-2">
                        <div class="col-6">
                          <div class="card card-element h-100">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Sesión actual</div>
                            <span class="d-flex flex-column justify-content-center align-items-center text-center w-100 gap-1">
                              <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100">
                                <i class="fa-solid fa-user text-secondary" style="font-size: 0.9rem;"></i>
                                <small class="fw-semibold text-dark">{{ getCtmCurrentUser() }}</small>
                              </span>
                              <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100">
                                <i class="fa-solid fa-hourglass-half text-warning" style="font-size: 0.9rem;"></i>
                                <small class="fw-semibold text-dark">{{ getCtmRemainingTime() }}</small>
                              </span>
                            </span>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card card-element h-100 d-flex flex-column justify-content-center align-items-center text-center">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Consumo mensual</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid fa-bolt text-warning" style="font-size: 1rem;"></i>
                              <span class="fw-semibold text-dark align-middle">{{ getCtmMonthlyConsumption() }} kWh</span>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="row g-2">
                        <div class="col-6">
                          <div class="card card-element h-100 d-flex flex-column justify-content-center align-items-center text-center">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Coste estimado mes</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid fa-euro-sign text-warning" style="font-size: 1rem;"></i>
                              <span class="fw-semibold text-dark align-middle">{{ getCtmEstimatedCost() | number:'1.2-2' }}€</span>
                            </span>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card card-element h-100 d-flex flex-column justify-content-center align-items-center text-center">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Beneficios mes</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid fa-sack-dollar text-success" style="font-size: 1rem;"></i>
                              <span class="fw-semibold text-dark align-middle">{{ getMonthlyRevenue() | number:'1.2-2' }}€</span>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="row g-2">
                        <div class="col-6">
                          <div class="card card-element h-100">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Tiempo total mes</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid fa-clock text-info" style="font-size: 1rem;"></i>
                              <span class="fw-semibold text-dark align-middle">{{ getCtmActiveTimeFormatted() }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card card-element h-100">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Tiempo total de uso</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid fa-history text-purple" style="font-size: 1rem;"></i>
                              <span class="fw-semibold text-dark align-middle">{{ getCtmTotalUsageTime() }}</span>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="row g-2">
                        <div class="col-6">
                          <div class="card card-element h-100 d-flex flex-column justify-content-center align-items-center text-center">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Tendencia energía</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid fa-bolt text-warning" style="font-size: 1rem;"></i>
                              <i class="fa-solid" [ngClass]="getCtmEnergyTrend() >= 0 ? 'fa-arrow-up' : 'fa-arrow-down'" [style.color]="getCtmEnergyTrend() >= 0 ? 'green' : 'red'"></i>
                              <span class="fw-semibold text-dark align-middle">{{ getCtmEnergyTrend() | number:'1.1-1' }}<i class="fa-solid fa-percent"></i></span>
                            </span>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card card-element h-100 d-flex flex-column justify-content-center align-items-center text-center">
                            <div class="card-header bg-white border-bottom-0 d-flex justify-content-center align-items-center text-center text-uppercase">Tendencia tiempo</div>
                            <span class="d-flex flex-row justify-content-center align-items-center text-center gap-2 w-100 align-middle">
                              <i class="fa-solid fa-clock text-info" style="font-size: 1rem;"></i>
                              <i class="fa-solid" [ngClass]="getCtmTimeTrend() >= 0 ? 'fa-arrow-up' : 'fa-arrow-down'" [style.color]="getCtmTimeTrend() >= 0 ? 'green' : 'red'"></i>
                              <span class="fw-semibold text-dark align-middle">{{ getCtmTimeTrend() | number:'1.1-1' }}<i class="fa-solid fa-percent"></i></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Sección de reparto de gastos con tabla y gráfico circular -->
                <div class="row mt-3">
                  <div class="col-md-8">
                    <div class="chart-header mb-3">
                      <h5 class="text-muted mb-0">Reparto de gastos</h5>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-striped table-hover card-table">
                        <thead class="table-light">
                          <tr>
                            <th>ID</th>
                            <th>Usuario</th>
                            <th>Tiempo (horas)</th>
                            <th>Consumo (kWh)</th>
                            <th>Coste (€)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let user of usersData">
                            <td><span class="badge bg-secondary">{{ user.id }}</span></td>
                            <td><strong class="text-dark">{{ user.name }}</strong></td>
                            <td><strong class="text-dark">{{ user.time }}h</strong></td>
                            <td><strong class="text-dark">{{ user.consumption }} kWh</strong></td>
                            <td><span class="badge bg-primary">{{ user.cost }}€</span></td>
                          </tr>
                        </tbody>
                        <tfoot class="table-light">
                          <tr>
                            <td colspan="2"><strong>Total</strong></td>
                            <td><strong>{{ getTotalTime() |  number:'1.2-2'}}h</strong></td>
                            <td><strong>{{ getTotalConsumption() |  number:'1.2-2'}} kWh</strong></td>
                            <td><strong>{{ getTotalCost() }}€</strong></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="chart-header mb-3">
                      <div class="d-flex align-items-center">
                        <h5 class="text-muted mb-0">{{ chartTitle }}</h5>
                      </div>
                      <div class="d-flex justify-content-end w-100 mt-1">
                        <div class="chart-controls" role="group" style="width: auto;">
                          <div class="btn-group btn-group-sm" aria-label="Tipo de gráfico">
                            <button type="button"
                                    class="btn btn-outline-primary"
                                    [ngClass]="{'active': currentChartType === 'hourly'}"
                                    (click)="switchChart('hourly')"
                                    title="Distribución horaria">
                              <i class="fas fa-clock"></i>
                            </button>
                            <button type="button"
                                    class="btn btn-outline-primary"
                                    [ngClass]="{'active': currentChartType === 'users'}"
                                    (click)="switchChart('users')"
                                    title="Consumo por usuario">
                              <i class="fas fa-users"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="pie-chart-container mb-4" style="max-height: 250px;" >
                      <canvas id="distributionChart" #distributionChart></canvas>
                    </div>

                    <!-- Leyenda para distribución horaria -->
                    <div class="chart-legend mt-3" *ngIf="currentChartType === 'hourly'">
                      <div class="legend-item d-flex align-items-center gap-2 mb-2">
                        <span class="legend-color rounded-circle" style="background-color: #ff6384; width:18px; height:18px;"></span>
                        <span class="legend-text text-muted">Punta (18:00-22:00)</span>
                      </div>
                      <div class="legend-item d-flex align-items-center gap-2 mb-2">
                        <span class="legend-color rounded-circle" style="background-color: #36a2eb; width:18px; height:18px;"></span>
                        <span class="legend-text text-muted">Llano (8:00-18:00, 22:00-24:00)</span>
                      </div>
                      <div class="legend-item d-flex align-items-center gap-2 mb-2">
                        <span class="legend-color rounded-circle" style="background-color: #4bc0c0; width:18px; height:18px;"></span>
                        <span class="legend-text text-muted">Valle (0:00-8:00)</span>
                      </div>
                    </div>

                    <!-- Leyenda para consumo por usuarios -->
                    <div class="chart-legend mt-3" *ngIf="currentChartType === 'users'">
                      <div class="legend-item d-flex align-items-center gap-2 mb-2" *ngFor="let user of usersData; let i = index">
                        <span class="legend-color rounded-circle" [style.background-color]="userColors[i]" style="width:18px; height:18px;"></span>
                        <span class="legend-text text-muted">{{ user.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
